import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Button from '@mui/material/Button';
import Alert from '../../Alert';
import CircularProgress from '@mui/material/CircularProgress';
import OrderCard from '../../OrderCard';
import postCambiarContrasenia from '../../Queries/postCambiarContrasenia';
import SectionTitle from '../../SectionTitle';

// Styles
import styles from './index.module.sass';

const ChangePassword = (props) => {
  const { device, getCookie, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('changepassword');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [changeFields, setChangeFields] = useState({
    current: '',
    new: '',
    newAgain: '',
  });
  const [typeInput, settypeInput] = useState('password');

  const handleChange = (e) => {
    setChangeFields({
      ...changeFields,
      [e.target.name]: e.target.value,
    });
  };

  async function handleSubmit(e) {
    const hasTE = changeFields?.new.substring(0, 2);
    if (parseInt(getCookie('usuarioOk')) > 9000000) {
      if (changeFields.new.includes(getCookie('usuarioOk'))) {
        alert('No puedes incluir tu número de kit en la contraseña');
        return;
      } else if (hasTE.toUpperCase() === 'TE') {
        alert('La contraseña no puede incluir la palabra TE al principio');
        return;
      }
    }

    setLoading(true);
    const response = await postCambiarContrasenia({
      jsonBody: {
        accion: 'CONTINUAR',
        usuarioOK: getCookie('usuarioOk'),
        contrasenia: changeFields.current,
        contraseniaNueva: changeFields.new,
        contraseniaNueva2: changeFields.newAgain,
      },
    });
    const { tipoMensaje = '', mensaje = '' } = response;
    setSessionMessage(mensaje);
    if (tipoMensaje === 'error') {
      setAlertText(mensaje);
      setOpen(true);
    } else {
      if (tipoMensaje === 'exito' && mensaje !== '') {
        setAlertText(mensaje);
        setOpen(true);
      }
      setChangeFields({
        current: '',
        new: '',
        newAgain: '',
      });
    }
    setLoading(false);
  }

  function seePsw() {
    if (typeInput === 'password') {
      settypeInput('text');
    } else {
      settypeInput('password');
    }
  }

  return (
    <div id={styles.ChangePassword} className={`${styles[screenSize]} ${styles.ChangePassword}`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <SectionTitle title={t('subtitle')} subtitle={t('title2')} />
      <div className={`${styles.container} ${styles[screenSize]}`}>
        <OrderCard>
          <div className={styles.info}>
            <span className={`material-icons-outlined ${styles.iconGold}`}>info</span>
            {t('title')}
          </div>
          <div className={styles.messageAlert}>{t('messageAlert')}</div>
          <div className={styles.form}>
            <div className={styles.title}>
              <label>{t('current')}</label>
            </div>
            <div className={styles.inputContainer}>
              <input
                type={typeInput}
                name='current'
                variant='outlined'
                value={changeFields.current}
                className={`${styles.textNumber} ${styles[screenSize]}`}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className={styles.title}>
              <label>{t('new')}</label>
            </div>
            <div className={styles.inputContainer}>
              <input
                name='new'
                type={typeInput}
                variant='outlined'
                value={changeFields.new}
                className={`${styles.textNumber} ${styles[screenSize]}`}
                onChange={(e) => handleChange(e)}
                maxLength='10'
              />
            </div>

            <div className={styles.title}>
              <label>{t('newAgain')}</label>
            </div>

            <div className={styles.inputContainer}>
              <input
                type={typeInput}
                name='newAgain'
                variant='outlined'
                value={changeFields.newAgain}
                className={`${styles.textNumber} ${styles[screenSize]}`}
                onChange={(e) => handleChange(e)}
                maxLength='10'
              />
              <div className={styles.inputDivPassword}>
                {(typeInput === 'password' && (
                  <i className={`material-icons ${styles.checkPassword}`} onClick={() => seePsw()}>
                    check_box_outline_blank
                  </i>
                )) || (
                  <i className={`material-icons ${styles.checkPassword}`} onClick={() => seePsw()}>
                    check_box
                  </i>
                )}
                <label className={styles.checkPassword}>{t('showPass')}</label>
              </div>
            </div>

            <div className={styles.buttonsContainer}>
              {(!loading && (
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  className={`${styles.button}`}
                  onClick={(e) => handleSubmit(e)}>
                  {(loading && <CircularProgress />) || (
                    <div className={styles.divButton}>
                      {t('textButton')} &nbsp;
                      <span className={`material-icons-outlined`}>arrow_right_alt</span>
                    </div>
                  )}
                </Button>
              )) || (
                <Button
                  type='submit'
                  variant='contained'
                  color='primary'
                  className={`${styles.buttonDisable}`}
                  disabled>
                  {(loading && <CircularProgress />) || (
                    <div className={styles.divButton}>
                      {t('textButton')} &nbsp;
                      <span className={`material-icons-outlined`}>arrow_right_alt</span>
                    </div>
                  )}
                </Button>
              )}
            </div>
          </div>
        </OrderCard>
      </div>
    </div>
  );
};

export default ChangePassword;
